import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Separator } from '../ui/separator';
import { Badge } from '../ui/badge';

const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().indexOf('MAC') >= 0;

const shortcuts = {
  'Navigation': [
    { keys: isMac ? ['⌘', 'D'] : ['Ctrl', 'D'], action: 'Go to Dashboard' },
    { keys: isMac ? ['⌘', 'A'] : ['Ctrl', 'A'], action: 'Go to Accounts' },
    { keys: isMac ? ['⌘', 'R'] : ['Ctrl', 'R'], action: 'Go to Reconciliations' },
    { keys: isMac ? ['⌘', 'K'] : ['Ctrl', 'K'], action: 'Open Command Palette' },
    { keys: isMac ? ['⌘', 'M'] : ['Ctrl', 'M'], action: 'Go to MD&A' },
    { keys: isMac ? ['⌘', 'F'] : ['Ctrl', 'F'], action: 'Go to FP&A' },
    { keys: isMac ? ['⌘', '/'] : ['Ctrl', '/'], action: 'Focus Search' },
  ],
  'Quick Actions': [
    { keys: isMac ? ['⌥', 'N'] : ['Alt', 'N'], action: 'Create New Item' },
    { keys: isMac ? ['⌥', 'S'] : ['Alt', 'S'], action: 'Save Current Form' },
    { keys: isMac ? ['⌥', 'E'] : ['Alt', 'E'], action: 'Export Data' },
  ],
  'General': [
    { keys: ['?'], action: 'Show Keyboard Shortcuts' },
    { keys: ['Esc'], action: 'Close Dialog/Clear Selection' },
  ]
};

export default function KeyboardShortcutsDialog({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {Object.entries(shortcuts).map(([category, items]) => (
            <div key={category}>
              <h3 className="text-sm font-semibold mb-3 text-muted-foreground">{category}</h3>
              <div className="space-y-2">
                {items.map((shortcut, idx) => (
                  <div key={idx} className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-accent transition-colors">
                    <span className="text-sm">{shortcut.action}</span>
                    <div className="flex items-center gap-1">
                      {shortcut.keys.map((key, keyIdx) => (
                        <Badge key={keyIdx} variant="outline" className="font-mono text-xs">
                          {key}
                        </Badge>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              {category !== 'General' && <Separator className="mt-4" />}
            </div>
          ))}
        </div>

        <div className="bg-muted/50 p-4 rounded-lg text-sm text-muted-foreground">
          <p className="font-medium mb-1">💡 Pro Tip:</p>
          <p>Press <Badge variant="outline" className="font-mono mx-1">Ctrl+K</Badge> to open the command palette for quick navigation.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
